import type { DrillStep } from '@strategy4kids/lessons';

/** The hint to show after `wrongAttempts` wrong tries on a drill step.
 *  Steps without a ladder fall back to their single `hint`. */
export function hintForAttempts(step: DrillStep, wrongAttempts: number): string | null {
  const ladder = step.hintLadder ?? (step.hint ? [step.hint] : []);
  if (ladder.length === 0) return null;
  return ladder[Math.min(wrongAttempts, ladder.length - 1)] ?? null;
}
